<template>
  <div class="row">
    <div class='col' style="border-right: 1px solid #e0e0e0">
      <h6 class="heading-small text-muted mb-2">Search by site</h6>

      <a-select
        showSearch
        placeholder="Select a site"
        style="width: 100%"
        @change="changeSiteFilter"
      >
        <a-select-option value="AllSites">All</a-select-option>
        <a-select-option v-for="site in dataSites" :key="site" :value="site">{{site}}</a-select-option>
      </a-select>

      <hr class="my-4" />
      <h6 class="heading-small text-muted mb-2">Filter by sync status</h6>
      <div>
        <a-radio-group defaultValue='0' @change="changeSyncFilter">
          <a-radio value="0">All</a-radio> <br>
          <a-radio value="Yes">Synced</a-radio> <br>
          <a-radio value="No">Not Synced</a-radio>
        </a-radio-group>
      </div>
    </div>
    
    <div class="col-10">
      <div class="card shadow" :class="type === 'dark' ? 'bg-default': ''">
        <div class="card-header border-0" :class="type === 'dark' ? 'bg-transparent': ''">
          <div class="row align-items-center">
            <div class="col-md-3">
              <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
                {{_.startCase(currentProfile)}}
              </h3>
            </div>
            <div v-if="serverType == 'branch'" class="col-md-9 text-right">
              <a-popconfirm title="Do you want to proceed?" @confirm="forceDeltaSync()" okText="Yes" cancelText="No">
                <base-button class="float-right ml-1" type="primary" size="sm">Force Delta Sync</base-button>
              </a-popconfirm>
            </div>
          </div>
        </div>
        <div class="table-responsive px-4">
          <VueTabulator ref="tabulator" v-model="data" :options="options" />
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
  import axios from "axios";
  import { mapState } from 'vuex'
  import secureStorage from '../../controllers/secureStorage';
  import HTTPRequest from '../../controllers/httpRequest.js';

  var component_x;

  export default {
    name: 'profiles-table',
    props: {
      type: {
        type: String
      },
      title: String
    },
    components: {
      
    },
    computed: {
      ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters', 'serverType', 'profileId'])
    },
    data: function() {    
      return {
        data: [],
        options: {
          layout:"fitDataStretch",
          pagination:"local",
          paginationSize:10,
          groupToggleElement:"header",
          groupBy:"site_name",
          groupHeader:this.groupHeader,
          groupStartOpen:false,
          columns:[
            {title: 'Synced', field: "is_latest", align:'center', formatter: this.is_latest_formatter, headerSort:false},
            {title: 'Profile', field: "profile", width:200, headerSort:false},
            {title: 'Profile Last Updated At', field: 'profile_last_updated_at', headerSort:false},
            {title: 'Site Delta Timestamp',  field: 'site_delta_timestamp', headerSort:false},
            {title: 'Number of Records', align:'center', field: 'no_of_records', headerSort:false},
            {title: 'Job Status', field: 'sync_status', headerSort:false},
          ],
        },
        dataSites: [],
      }
    },
    watch: {
      currentApiURL: function () {
        this.apiURL = this.currentApiURL
      },
      parameters: function () {
        this.apiURL = this.currentApiURL
        this.apiURL = this.apiURL + this.parameters
      }
    },
    methods: {
      async forceDeltaSync(){
        var delta_sync = await HTTPRequest.getRequest(component_x.endPoint+'/branch_delta_sync_details/force_delta_sync');
        if (delta_sync.msg == 'success'){
          this.$notification["success"]({
              message: 'Force Delta Sync',
              description: 'Request sent, please refresh page and wait for processing'
          });
        }
      },
      changeSyncFilter(e){
        var tabulatorInstance = this.$refs.tabulator.getInstance();
        var filter_sync_status = e.target.value
        if (filter_sync_status=="Yes") {
          tabulatorInstance.clearFilter();
          tabulatorInstance.addFilter("is_latest", "like", filter_sync_status);
        } else if (filter_sync_status=="No"){
          tabulatorInstance.clearFilter();
          tabulatorInstance.addFilter("is_latest", "like", filter_sync_status);
        } else {
          tabulatorInstance.clearFilter();
        }
      },
      changeSiteFilter(val){
        var tabulatorInstance = this.$refs.tabulator.getInstance();
        if (this.dataSites.includes(val)){
            tabulatorInstance.clearFilter();
            tabulatorInstance.addFilter("site_name", "like", val);
        }  else {
            tabulatorInstance.clearFilter();
        }
      },
      is_latest_formatter: function(cell, formatterParams, onRendered){
        var is_latest_format = ''
        var is_latest = cell.getValue();

        if (is_latest == 'Yes') 
          is_latest_format = "<span style='color: #00ff00;'><i class='fas fa-sync-alt'></i></span>"
        else
          is_latest_format = "<span style='color: #ff0000;'><i class='far fa-times-circle'></i></span>"

        return is_latest_format;
      },
      groupHeader:function(value, count, data, group){
        var is_latest_count = this.data.filter(d => d.is_latest=="Yes" && d.site_name == value).length
        var site_count = this.data.filter(d => d.site_name == value).length
        
        var group_sync_status = ''
        if (is_latest_count == site_count)
          group_sync_status = "<span style='color: #00ff00;'><i class='fas fa-sync-alt'></i></span>"
        else
          group_sync_status = "<span style='color: #ff0000;'><i class='fas fa-times-circle'></i></span>"
        
        var arrow_key = ''
        if (group._group.visible) {
          arrow_key = "<i class='fas fa-chevron-down'></i>"
        } else {
          arrow_key = "<i class='fas fa-chevron-right'></i>"
        }
        return arrow_key + group_sync_status + "  " + value + "<span style='color:#6468E3; margin-left:10px;'>" + is_latest_count + " out of "+ site_count + " profile(s) synced</span>";
      },
    },
    mounted: async function () {
      component_x = this;
      this.apiURL = this.currentApiURL
      if (this.serverType == 'branch') {
        this.data = await HTTPRequest.getRequest(component_x.endPoint+'/branch_delta_sync_details/get_branch_delta_sync_detail_from_ho');
      } else {
        this.data = await HTTPRequest.getRequest(component_x.apiURL);
      }

      if (this.data.length > 0) {
        this.dataSites = _.uniq(this.data.map(d => d.site_name));
      }
     
    }
  }
</script>


<style lang='scss'>
@import "~vue-tabulator/dist/scss/bootstrap/tabulator_bootstrap";
.tabulator-group-toggle{
    display: none;
}
</style>